import { Loader } from '@mantine/core';
import { forwardRef } from 'react';

import { LoaderIcon } from '@apple/assets/icons';

const RingLoader = forwardRef<HTMLElement, React.HTMLAttributes<HTMLElement>>((props, ref) => (
	<LoaderIcon {...props} ref={ref} />
));

export const LoaderTheme = Loader.extend({
	defaultProps: {
		loaders: {
			...Loader.defaultLoaders,
			ring: RingLoader,
		},
		type: 'oval',
	},
});
